"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore file */
var Gateway_1 = require("./PrimitiveTypes/Gateway");
var Errors_1 = require("../../../helpers/Errors");
/*
 * AR750SGateway.ts
 *
 * generated by generate_models_from_hephaestus_templates.js at 2021-12-10T16:43:47.484Z
 * should target equipment created using hephaestus template "AR750S Gateway" (60493c8f375c6a2bfceac842)
 *
 * list AR750SGateway equipment using chariot.js:

import Chariot from '@fsg/chariot.js';

const chariot = new Chariot();

await chariot.Equipment.list({
  params: {
    "metadata.hephaestus.template_id": "60493c8f375c6a2bfceac842"
  }
});

 *
 */
var AR750SGateway = /** @class */ (function (_super) {
    __extends(AR750SGateway, _super);
    function AR750SGateway() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pointNames = {
            lanIp: "lan",
            wanIp: "wan",
            publicIp: "public_ip",
            virtualIp: "vip",
            uptime: "uptime",
            memoryUsed: "mem_used",
            storageAvailable: "overlay_available"
        };
        return _this;
    }
    AR750SGateway.prototype.validate = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, ((_b = (_a = this._.metadata) === null || _a === void 0 ? void 0 : _a.hephaestus) === null || _b === void 0 ? void 0 : _b.template_id) == "60493c8f375c6a2bfceac842"];
            });
        });
    };
    AR750SGateway.prototype.getUptime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var point, value, seconds, percent, color;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.findPointByName("uptime")];
                    case 1:
                        point = _a.sent();
                        if (!point)
                            throw new Errors_1.InternalServerError("Uptime point missing on ".concat(this.getDisplayName()));
                        return [4 /*yield*/, point.getValue()];
                    case 2:
                        value = _a.sent();
                        if (typeof value !== "string")
                            throw new Errors_1.InternalServerError("Uptime point value is unexpected format");
                        seconds = value.split(":").map(function (segment, index, array) {
                            // get position relative to the end of the string
                            switch (array.length - index - 1) {
                                case 0: // seconds
                                    return parseInt(segment);
                                case 1: // minutes
                                    return parseInt(segment) * 60;
                                case 2: // hours
                                    return parseInt(segment) * 60 * 60;
                                case 3: // days
                                    return parseInt(segment) * 60 * 60 * 24;
                                default: // ts fix
                                    return 0;
                            }
                        }).reduce(function (total, number) { return number + total; }, 0);
                        percent = Math.round((seconds / (60 * 60 * 24)) * 100);
                        if (percent > 100)
                            percent = 100;
                        color = percent >= 99 ? "green" : percent >= 90 ? "blue" : "red";
                        return [2 /*return*/, {
                                seconds: seconds,
                                percent: percent,
                                color: color
                            }];
                }
            });
        });
    };
    AR750SGateway.prototype.getMemory = function () {
        return __awaiter(this, void 0, void 0, function () {
            var usedPoint, totalPoint, used, total, percent, color;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.findPointByName("mem_used")];
                    case 1:
                        usedPoint = _a.sent();
                        return [4 /*yield*/, this.findPointByName("mem_total")];
                    case 2:
                        totalPoint = _a.sent();
                        if (!usedPoint || !totalPoint)
                            throw new Errors_1.InternalServerError("Memory points missing on ".concat(this.getDisplayName()));
                        return [4 /*yield*/, usedPoint.getValue()];
                    case 3:
                        used = (_a.sent()) || 0;
                        return [4 /*yield*/, totalPoint.getValue()];
                    case 4:
                        total = (_a.sent()) || 0;
                        if (used === undefined || used === null || typeof used == "boolean")
                            throw new Errors_1.InternalServerError("mem_used point value is unexpected format");
                        if (total === undefined || total === null || typeof total == "boolean")
                            throw new Errors_1.InternalServerError("mem_total point value is unexpected format");
                        if (typeof used !== "number")
                            used = parseFloat(used);
                        if (typeof total !== "number")
                            total = parseFloat(total);
                        if (isNaN(used))
                            used = 0;
                        if (isNaN(total))
                            total = 1;
                        percent = Math.round((used / total) * 100) || 0;
                        color = percent >= 80 ? "red" : percent > 50 ? "blue" : "green";
                        return [2 /*return*/, {
                                used: used,
                                percent: percent,
                                color: color
                            }];
                }
            });
        });
    };
    AR750SGateway.prototype.getStorageUsage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var overlayAvailablePoint, value, percent, color;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.findPointByName("overlay_available")];
                    case 1:
                        overlayAvailablePoint = _a.sent();
                        if (!overlayAvailablePoint)
                            throw new Errors_1.InternalServerError("overlay_available point missing on ".concat(this.getDisplayName()));
                        return [4 /*yield*/, overlayAvailablePoint.getValue()];
                    case 2:
                        value = _a.sent();
                        if (value === undefined || value === null || typeof value == "boolean")
                            throw new Errors_1.InternalServerError("overlay_available point value is unexpected format");
                        if (typeof value !== "number")
                            value = parseFloat(value) || 0;
                        percent = Math.round((value / 128) * 100) || 0;
                        color = percent >= 80 ? "red" : percent > 50 ? "blue" : "green";
                        return [2 /*return*/, {
                                percent: percent,
                                color: color
                            }];
                }
            });
        });
    };
    AR750SGateway.prototype.lookup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.lookupResponse) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/ipam/clients/".concat(this._.external_id)
                            })];
                    case 1:
                        _a.lookupResponse = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.lookupResponse];
                }
            });
        });
    };
    AR750SGateway.prototype.getClients = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lookup;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.lookup()];
                    case 1:
                        lookup = _a.sent();
                        return [2 /*return*/, lookup.clients];
                }
            });
        });
    };
    return AR750SGateway;
}(Gateway_1.default));
exports.default = AR750SGateway;
